import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { message, Modal, Tooltip } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { workwiseServices } from '../WorkW-Api/workWiseApi';
import { slideAction } from '../../store/slideSlice';

const { confirm } = Modal;

const CompleteDocument = () => {
    const dispatch = useDispatch();
    const { referenceId } = useSelector((state) => state.slide.documentInformation);

    const handleClick = async () => {
        try {
            await workwiseServices.completeDocument(referenceId);
            message.success('Document completed successfully.');
           dispatch(slideAction.setIsReadOnly(true));
        } catch (error) {
            message.error('Failed to complete the document. Please try again.');
        }
    };

    const showConfirmationModal = (e) => {
        e.preventDefault();
        confirm({
            title: 'Are you sure you want to complete this document?',
            content: 'This action cannot be undone.',
            onOk() {
                handleClick();
            },
            onCancel() {
            },
            zIndex: 9999, 
            maskClosable:true,
        });
    };

    return (
        <Tooltip title="Complete Document" placement="bottom">
            <button
                className="header-icon-btn"
                onClick={(e) => showConfirmationModal(e)}
                aria-label="Complete Document"
            >
                <CheckCircleOutlined style={{ fontSize: '16px' }} />
            </button>
        </Tooltip>
    );
};

export default CompleteDocument;